import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const quickLinks = [
    { label: 'About Us', href: '/about', isPage: true },
    { label: 'Careers', href: '/careers', isPage: true },
    { label: 'Contact', href: '/contact', isPage: true },
    { label: 'Case Studies', href: '#', isPage: false },
    { label: 'Blog', href: '/blog', isPage: true }
  ];
  const socialLinks = [
    { name: 'LinkedIn', icon: 'ri-linkedin-fill' },
    { name: 'Twitter', icon: 'ri-twitter-x-fill' },
    { name: 'Facebook', icon: 'ri-facebook-fill' },
    { name: 'YouTube', icon: 'ri-youtube-fill' }
  ];

  return (
    <footer className="bg-[#1A2332] text-white">
      {/* Upper Footer */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-16">
          {/* Column 1 - Company */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-[#0066CC] flex items-center justify-center">
                <i className="ri-code-s-slash-line text-xl text-white"></i>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm">
              Leading IT services provider delivering innovative solutions that empower businesses to thrive in the digital age.
            </p>
          </div>

          {/* Column 2 - Newsletter */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-6 whitespace-nowrap">
              Stay Updated
            </h4>
            <div className="relative mb-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full bg-transparent border-b border-gray-600 py-3 pr-10 text-white placeholder-gray-500 focus:border-[#0066CC] focus:outline-none transition-colors"
              />
              <button className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center hover:text-[#0066CC] transition-colors">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500">
              By subscribing, you agree to our{' '}
              <a href="#" className="text-[#0066CC] hover:underline whitespace-nowrap">
                Privacy Policy
              </a>
            </p>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-6 whitespace-nowrap">
              Quick Links
            </h4>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  {link.isPage ? (
                    <Link
                      to={link.href}
                      className="text-white hover:text-[#0066CC] transition-colors text-sm whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-white hover:text-[#0066CC] transition-colors text-sm whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Connect */}
          <div>
            <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-6 whitespace-nowrap">
              Connect
            </h4>
            <ul className="space-y-4">
              {socialLinks.map((social, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="flex items-center text-white hover:text-[#0066CC] transition-colors text-sm group whitespace-nowrap"
                  >
                    <i className={`${social.icon} text-lg mr-3`}></i>
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-gray-400 text-center md:text-left">
            © 2026 Patriot Defense Technologies LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
            <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
